import classNames from 'classnames'
import { Icon } from 'components/common/Icon'
import { PropsWithClassName } from 'types'

interface Props extends PropsWithClassName {
  iconSize?: number
}

export function TrustpilotRectangle({ className, iconSize }: Props) {
  return (
    <div
      className={classNames(
        'relative flex items-center justify-center rounded bg-[#00B67A] p-0.5',
        className
      )}
    >
      <Icon
        name='trustpilot'
        custom
        size={iconSize}
        className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'
      />
    </div>
  )
}
